import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist-indexeddb-storage";
import reducer from "./reducer";

const persistConfig = {
  key: "root",
  storage: storage("cacDB"),
};
const persistedReducer = persistReducer(persistConfig, reducer);
let store = createStore(persistedReducer, composeWithDevTools());
let persistor = persistStore(store);
export { store, persistor };
